import { apiClient } from "@/api/api-client";
import createBaseService from "@/api/base-service.ts";
import type { z } from "zod";
import type { Invoice, InvoiceJournalItems } from "../../types/invoice";

const invoiceService = {
	...createBaseService<Invoice>("/invoices"),
	preview: async (params = {}): Promise<Blob> => {
		const response = await apiClient.post("/invoice-download", params, {
			responseType: "blob",
		});

		return new Blob([response.data], { type: "application/pdf" });
	},
	getJournalItems: async (invoiceId: string): Promise<InvoiceJournalItems> => {
		const response = await apiClient.get<{ data: InvoiceJournalItems }>(`/invoices/${invoiceId}/journal-items`);
		return response.data.data;
	},
	postJournalEntry: async (invoiceId: string, status: "draft" | "posted" = "posted"): Promise<InvoiceJournalItems> => {
		const response = await apiClient.post<{ data: InvoiceJournalItems }>(`/invoices/${invoiceId}/journal-entries`, { status });
		return response.data.data;
	},
	cancel: async (invoiceId: string, reason: string, reclassify_target_account_code?: string) => {
		const response = await apiClient.post<{
			data: Invoice;
			books: { reversal_id: string | null; reclassify_id: string | null };
		}>(`/invoices/${invoiceId}/cancel`, {
			reason,
			...(reclassify_target_account_code ? { reclassify_target_account_code } : {}),
		});
		return response.data;
	},
	// deleteByIdPermanently: async (id: string) => {
	// 	await apiClient.post("/articles-delete-permanently", { id: id });
	// },
	// uploadImage: async (values: z.infer<typeof uploadTiptapFormSchema>) => {
	// 	const formData = new FormData();

	// 	formData.append("images", values);

	// 	const response = await apiClient.post("/image-upload", formData);

	// 	return response.data;
	// },
};

export default invoiceService;
